import React from "react";
import { Container, Stack, Flex, Link } from "basis";

import { Icon, Text, Button } from "../";
import { appUrl } from "../../core/config";
import { getErrorDetails } from "./utils";
import { ERROR_CODES } from "./constants";
import { COLOR } from "../theme";

const ErrorMessage = ({
  type = ERROR_CODES.DEFAULT,
  title,
  description,
  additionalParams = {},
  test = false,
  color = COLOR.LATITUDE_BLUE_INDIGO,
  isShowImage = true,
}) => {
  let error = { title, description };
  if (!title || !description) {
    error = getErrorDetails(type, additionalParams);
  }
  return (
    <Container
      padding="12 0 0 0"
      hasBreakpointWidth
      testId={`error-message-${type}`}
    >
      <Stack align="center" gap="4">
        <Text align="center" textStyle="heading3" color={color} fontFamily="LatitudeSans">
          {error?.title}
        </Text>

        <Text textStyle="subtitle1" align="center" color={color}>
          {description ?? error?.description}
        </Text>

        <Container padding="8 0">
           {error && error?.iconType && !test && isShowImage && (
            <Flex placeItems="center">
              {error && error?.iconType && !test && isShowImage && (
                <Icon type={error?.iconType} size="200px" />
              )}
            </Flex>
          )}
        </Container>

        {additionalParams?.transactionId && (
          <Text textStyle="subtitle2" align="center" color={color}>
            Ref: {additionalParams?.transactionId}
          </Text>
        )}

        {additionalParams?.urlCancel && additionalParams?.urlCancel !== appUrl && (
          <Button
            showButton
            margin="0 0 6 0"
            customVariant="primary"
            onClick={() => {
              window.location.href = additionalParams?.urlCancel;
            }}
            >
              {additionalParams?.urlCancelLabel ?? "Return to cart"}
          </Button>
        )}

        {error?.addt && <Text align="center" color={color}>{error.addt}</Text>}
      </Stack>
    </Container>
  );
};

export { ErrorMessage, ERROR_CODES };
